<div
  class="w-full lg:max-w-full lg:flex login-page"
  class="w-full lg:max-w-full lg:flex login-page"
>
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url('assets/img/Background formulaire candidature Force-N.jpeg');
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    "
  >
    <div class="w-4/5 grid-cols-1 flex place-content-center">
      <app-card-form style="opacity: 0.7">
        <div id="page-one">
          <div class="flex justify-between mb-10">
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_unchk.png')"
            ></div>
            <div
              class="logo-icon"
              style="background-image: url('assets/img/logo_master_card.png')"
            ></div>
          </div>
          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="font-bold text-2xl">
                FORMULAIRE D'INSCRIPTION POUR LA PROMOTION DES STEM
              </span>
              <br />
              Programme Force-N
            </div>
          </div>
          <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
          <div class="flex justify-center items-center">
            <div class="text-center">
              <span class="underline text-blue-800"
                ><a
                  href="https://sciences.force-n.sn/course/index.php?categoryid=2/"
                  target="_blank"
                  >Vous souhaitez en savoir plus avant de vous inscrire? Cliquez
                  ici pour obtenir plus de détails sur ce programme .</a
                >
              </span>
              <br />
              <br />
              <br />
              <!-- <span class="font-bold text-2xl">
                Délai limite pour le dépôt des dossiers de candidature
              </span> -->
              <br />
              <br />
              <!-- {{ appelCloseDate | date : "EEEE d MMMM y, à " }} 23h:59mn -->
            </div>
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="inscriptionForm" class="space-y-6">
            <div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >I. INFORMATIONS PERSONNELLES</span
                >
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Prénom - Nom &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="
                        isFieldInvalid('firstname') ||
                        isFieldInvalid('lastname')
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                    formControlName="firstname"
                    [style.border]="
                      isFieldInvalid('firstname') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <div class="mt-3"><p>Prénom</p></div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="text"
                    id="nom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="lastname"
                    [style.border]="
                      isFieldInvalid('lastname') ? '2px solid #eb1c1c' : ''
                    "
                  />
                  <div class="mt-3"><p>Nom</p></div>
                </div>
              </div>
              <div class="relative">
                <div class="grid lg:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3">
                        Date de naissance &nbsp;
                        <p style="color: red">*</p>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('dateBirth')"
                        style="color: #eb1c1c"
                      >
                        Champ requis!
                      </div>
                      <!-- <div *ngIf="checkValidAge()" style="color: #eb1c1c">
                        L'âge limite de candidature est de 35 ans !
                      </div> -->
                    </div>
                  </div>
                  <div class="col-span-2">
                    <div class="flex justify-between gap-3">
                      <div class="w-full">
                        <input
                          type="date"
                          formControlName="dateBirth"
                          id="year"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                          [style.border]="
                            isFieldInvalid('dateBirth')
                              ? '2px solid #eb1c1c'
                              : ''
                          "
                        />

                        <div class="mt-3">
                          <p>
                            Saisir votre date de naissance ou vous pouvez
                            directement selectionner la date dans l'agenda.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Sexe &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('gender')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="gender"
                      id="gender-1"
                      type="radio"
                      value="1"
                      name="gender"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('gender') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="gender"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Masculin</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="gender"
                      id="gender-2"
                      value="2"
                      type="radio"
                      name="gender"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('gender') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="gender"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Féminin</label
                    >
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 md:gap-6">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Numéro de téléphone &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="
                        isFieldInvalid('phoneNumberOne') ||
                        isFieldInvalid('phoneCodeOne')
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <select
                    type="text"
                    id="phoneCodeOne"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                    formControlName="phoneCodeOne"
                    [style.border]="
                      isFieldInvalid('phoneCodeOne') ? '2px solid #eb1c1c' : ''
                    "
                  >
                    <option
                      *ngFor="let phonecode of phoneCode"
                      [value]="phonecode.phoneCode"
                    >
                      {{ phonecode.phoneCode }}
                    </option>
                  </select>
                  <div class="mt-3"><p>Indicatif pays</p></div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="tel"
                    id="phoneNumberOne"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="phoneNumberOne"
                    onlyNumber
                    [style.border]="
                      isFieldInvalid('phoneNumberOne')
                        ? '2px solid #eb1c1c'
                        : ''
                    "
                  />
                  <div class="mt-3"><p>Numéro de téléphone</p></div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Ce numéro est-il disponible sur <br />
                      Whatsapp? &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('isWhatsApp')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="isWhatsApp"
                      id="isWhatsApp"
                      type="radio"
                      value="OUI"
                      name="isWhatsApp"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="isWhatsApp"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Oui</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="isWhatsApp"
                      checked
                      id="isWhatsApp-2"
                      type="radio"
                      value="NON"
                      name="isWhatsApp"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="isWhatsApp"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Non</label
                    >
                  </div>
                </div>
              </div>

              <div
                class="grid md:grid-cols-3 md:gap-6"
                *ngIf="showWhatsAppNumberFields"
              >
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Numéro Whatsapp &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="
                        isFieldInvalid('phoneNumberTwo') ||
                        isFieldInvalid('phoneCodeTwo')
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="relative z-0 w-full group">
                  <select
                    type="text"
                    id="prenom"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                    formControlName="phoneCodeTwo"
                    [style.border]="
                      isFieldInvalid('phoneCodeTwo') ? '2px solid #eb1c1c' : ''
                    "
                  >
                    <option
                      *ngFor="let phonecode of phoneCodeWhatsapp"
                      [value]="phonecode.phoneCode"
                    >
                      {{ phonecode.phoneCode }}
                    </option>
                  </select>
                  <div class="mt-3"><p>Indicatif pays</p></div>
                </div>
                <div class="relative z-0 w-full group">
                  <input
                    type="tel"
                    id="phoneNumberTwo"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="phoneNumberTwo"
                    onlyNumber
                    [style.border]="
                      isFieldInvalid('phoneNumberTwo')
                        ? '2px solid #eb1c1c'
                        : ''
                    "
                  />
                  <div class="mt-3"><p>Numéro de téléphone</p></div>
                </div>
              </div>

              <div formGroupName="emailGroup">
                <div class="grid md:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3">
                        Adresse email &nbsp;
                        <p style="color: #ff0000">*</p>
                      </div>

                      <div
                        *ngIf="isFieldInvalidForMails('emailGroup.email')"
                        style="color: #eb1c1c"
                      >
                        Champ requis!
                      </div>
                      <div
                        *ngIf="isMailFieldInvalid('email')"
                        style="color: #eb1c1c"
                      >
                        Format de l'email invalide.
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        type="text"
                        id="email"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        placeholder="Par ex : monnom@exemple.com"
                        formControlName="email"
                        [style.border]="
                          isFieldInvalid('emailGroup.email')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="grid md:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3"></div>
                    </div>

                    <div
                      *ngIf="isFieldInvalidForMails('emailGroup.confirmEmail')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!.
                    </div>
                    <div
                      *ngIf="isMailFieldInvalid('confirmEmail')"
                      style="color: #eb1c1c"
                    >
                      Format de l'email invalide.
                    </div>

                    <div
                      *ngIf="showEmailErrors$ | async"
                      style="color: #eb1c1c"
                    >
                      Mettez des mails identiques!
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        type="email"
                        id="confirmEmail"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        formControlName="confirmEmail"
                        [style.border]="
                          isFieldInvalid('emailGroup.confirmEmail')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <div class="mt-3">
                        <p>
                          Pour être sûr de bien recevoir nos mails, 
                          merci d'utiliser des adresses type Gmail, 
                          Evitez les adresses Outlook, Yahoo, Hotmail et professionnelles.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div formGroupName="passwordGroup">
                <div class="grid md:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3">
                        Mot de passe &nbsp;
                        <p style="color: #ff0000">*</p>
                      </div>

                      <div
                        *ngIf="isFieldInvalidForMails('passwordGroup.password')"
                        style="color: #eb1c1c"
                      >
                        Champ requis!
                      </div>
                      <div
                        *ngIf="isPasswordFieldInvalid('password')"
                        style="color: #eb1c1c"
                      >
                        Format invalide.
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        type="password"
                        id="password"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        formControlName="password"
                        [style.border]="
                          isFieldInvalid('passwordGroup.password')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="grid md:grid-cols-3 gap-6 my-6">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3"></div>
                    </div>

                    <div
                      *ngIf="
                        isFieldInvalidForMails('passwordGroup.confirmPassword')
                      "
                      style="color: #eb1c1c"
                    >
                      Champ requis!.
                    </div>
                    <div
                      *ngIf="isPasswordFieldInvalid('confirmPassword')"
                      style="color: #eb1c1c"
                    >
                      Format mdp invalid.
                    </div>

                    <div
                      *ngIf="showPasswordErrors$ | async"
                      style="color: #eb1c1c"
                    >
                      Mettez des mot de passe identiques!
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input
                        type="password"
                        id="confirmPassword"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        formControlName="confirmPassword"
                        [style.border]="
                          isFieldInvalid('passwordGroup.confirmPassword')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <div class="mt-3">
                        <p>
                          Le mot de passe doit comporter au moins 8
                          caractère(s), au moins 1 chiffre(s), au moins 1
                          minuscule(s), au moins 1 majuscule(s), au moins 1
                          caractère(s) spéciaux tels que *, - ou #
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Nationalité &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('country')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>

                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="country"
                      id="country-1"
                      type="radio"
                      value="Sénégal"
                      name="country"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('country') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="bordered-radio-2"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Sénégalaise</label
                    >
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center ps-4">
                    <input
                      formControlName="country"
                      checked
                      id="country-2"
                      type="radio"
                      value="Autre"
                      name="country"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('country') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <label
                      for="country"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >Autre</label
                    >
                  </div>
                </div>
              </div>
              <!-- if other coutry -->

              <div
                class="grid md:grid-cols-3 gap-6 my-6"
                *ngIf="showOtherCountryField"
              >
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez votre nationalité &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('otherCountry')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      type="text"
                      id="otherCountry"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      formControlName="otherCountry"
                      [style.border]="
                        isFieldInvalid('otherCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let country of countries"
                        [value]="country.name"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Région de résidence &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('region')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="region"
                      id="region"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('region') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option
                        *ngFor="let region of regions"
                        [value]="region.name"
                      >
                        {{ region.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Ville de résidence &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div *ngIf="isFieldInvalid('city')" style="color: #eb1c1c">
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="city"
                      id="city"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('city') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option *ngFor="let city of cities" [value]="city.id">
                        {{ city.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl"
                  >II. INFORMATIONS SCOLAIRES
                </span>
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Etablissement d'enseignement &nbsp;
                      <p style="color: #ff0000">*</p>
                    </div>

                    <div
                      *ngIf="isFieldInvalidForMails('establishment')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <input
                      type="text"
                      id="establishment"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="establishment"
                      [style.border]="
                        isFieldInvalid('establishment')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Classe &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div
                      *ngIf="isFieldInvalid('classe')"
                      style="color: #eb1c1c"
                    >
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="classe"
                      id="classe"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('classe') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option
                        *ngFor="let classe of classes"
                        [value]="classe.name"
                      >
                        {{ classe.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Série &nbsp;
                      <p style="color: red">*</p>
                    </div>
                    <div *ngIf="isFieldInvalid('serie')" style="color: #eb1c1c">
                      Champ requis!
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select
                      formControlName="serie"
                      id="serie"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('serie') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option *ngFor="let serie of series" [value]="serie.name">
                        {{ serie.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <hr class="h-1 my-8 bg-green-500 border-0 dark:bg-gray-700" />
              <div
                class="flex justify-center items-center"
                *ngIf="isSucces"
                style="color: #23eb1c"
              >
                Inscription reussie!
              </div>

              <div
                class="flex justify-center items-center"
                *ngIf="fillAllFields"
                style="color: #eb1c1c"
              >
                Veuillez renseigner tous les champs requis!
              </div>

              <div class="flex justify-end items-center">
                <button
                  type="submit"
                  class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 btn-login"
                  (click)="onSubmitForm()"
                >
                  Soumettre
                </button>
              </div>

              <div class="flex justify-center mt-8">
                <div
                  class="logo-icon"
                  style="background-image: url('assets/img/logo_force_n.png')"
                ></div>
              </div>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>
